var map = {
	"./bedrock": 8370,
	"./bedrock.test": 8895,
	"./bedrock.test.ts": 8895,
	"./bedrock.ts": 8370,
	"./confirmationEmail.test": 1883,
	"./confirmationEmail.test.ts": 1883,
	"./core": 2736,
	"./core.ts": 2736,
	"./cpf": 5088,
	"./cpf.test": 2236,
	"./cpf.test.ts": 2236,
	"./cpf.ts": 5088,
	"./csc": 7450,
	"./csc.appointments.test": 6166,
	"./csc.appointments.test.ts": 6166,
	"./csc.ts": 7450,
	"./dcat": 7184,
	"./dcat.ts": 7184,
	"./disposal": 5322,
	"./disposal.ts": 5322,
	"./gdad": 8998,
	"./gdad.ts": 8998,
	"./gfie": 8607,
	"./gfie.test": 7688,
	"./gfie.test.ts": 7688,
	"./gfie.ts": 8607,
	"./invite": 694,
	"./invite.ts": 694,
	"./psfa": 9810,
	"./psfa.autofill-math.test": 8054,
	"./psfa.autofill-math.test.ts": 8054,
	"./psfa.list-bulk-upload.test": 6958,
	"./psfa.list-bulk-upload.test.ts": 6958,
	"./psfa.order.test": 8807,
	"./psfa.order.test.ts": 8807,
	"./psfa.ts": 9810,
	"./reward": 729,
	"./reward.encoding.test": 7899,
	"./reward.encoding.test.ts": 7899,
	"./reward.ts": 729,
	"./rpalogin": 6573,
	"./rpalogin.ts": 6573,
	"./scs": 9998,
	"./scs.minimum-standards.test": 4803,
	"./scs.minimum-standards.test.ts": 4803,
	"./scs.share-objective.test": 8421,
	"./scs.share-objective.test.ts": 8421,
	"./scs.ts": 9998,
	"./secondments": 3201,
	"./secondments.test": 6658,
	"./secondments.test.ts": 6658,
	"./secondments.ts": 3201,
	"./tableau": 20,
	"./tableau.test": 4607,
	"./tableau.test.ts": 4607,
	"./tableau.ts": 20
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5887;